import { getData, postData } from '@/assets/js/api.js'

/* 通过projectCode获取设计家方案接口 */
export const GetSchemeDetailByProjectCode = (params, fn) => {
  const methods = '/businessapi/Design/GetSchemeDetailByProjectCode'
  return getData(methods, params, 1, fn)
}

/* 通过GpNo来获取设计家方案接口 */
export const GetSchemeDetailByGpNo = (params, fn) => {
  const methods = '/businessapi/Design/GetSchemeDetailByGpNo'
  return getData(methods, params, 1, fn)
}

/* 获取查询设备信息接口 */
export const QueryBindFuncDeviceList = (params, fn) => {
  const methods = '/businessapi/Design/QueryBindFuncDeviceList'
  return getData(methods, params, 1, fn)
}

/* 初始化电子地图 */
export const AddSchemeDetail = (params, fn) => {
  const methods = '/businessapi/Design/AddSchemeDetailV2'
  return postData(methods, params, 1, fn)
}

/* 新增点位 */
export const AddPoint = (params, fn) => {
  const methods = '/businessapi/Design/AddPoint'
  return postData(methods, params, 1, fn)
}

/* 删除点位 */
export const DeletePoint = (params, fn) => {
  const methods = '/businessapi/Design/DeletePoint'
  return postData(methods, params, 1, fn)
}

/* 移动点位 */
export const MovePoint = (params, fn) => {
  const methods = '/businessapi/Design/MovePoint'
  return postData(methods, params, 1, fn)
}

/* 新增图片 */
export const AddImage = (params, fn) => {
  const methods = '/businessapi/Design/AddImage'
  return postData(methods, params, 1, fn)
}

/* 更新图片 */
export const UpdateImage = (params, fn) => {
  const methods = '/businessapi/Design/UpdateImage'
  return postData(methods, params, 1, fn)
}

/* 添加房间 */
export const AddRoom = (params, fn) => {
  const methods = '/businessapi/Design/AddRoom'
  return postData(methods, params, 1, fn)
}

/* 更新房间 */
export const UpdateRoom = (params, fn) => {
  const methods = '/businessapi/Design/UpdateRoom'
  return postData(methods, params, 1, fn)
}

/* 删除房间 */
export const DeleteRoom = (params, fn) => {
  const methods = '/businessapi/Design/DeleteRoom'
  return postData(methods, params, 1, fn)
}

/* 更改虚拟设备名称 */
export const updateName = (params, fn) => {
  const methods = '/businessapi/Design/UpdatePointName'
  return postData(methods, params, 1, fn)
}

/* 更改房间名称 */
export const UpdateRoomName = (params, fn) => {
  const methods = '/businessapi/Design/UpdateRoomName'
  return postData(methods, params, 1, fn)
}

/* 更新点位和房间信息 */
export const UpdateRoomAndMovePoint = (params, fn) => {
  const methods = '/businessapi/Design/UpdateRoomAndMovePoint'
  return postData(methods, params, 1, fn);
}